import * as queryString from 'query-string';
import isBackOffice from 'utils/appUtils';
import { navtoLogin } from 'utils/navigate';
import { API_URL } from 'env';

const API_ENDPOINT = API_URL;

const PUBLIC_API = `${API_ENDPOINT}/appraiser-registration-api`;
const OFFICE_API = `${API_ENDPOINT}/vxvalue/service/appraiser-registration-api/appraiser-registration-api`;

export const getApiUrl = () => (isBackOffice ? OFFICE_API : PUBLIC_API);

export const endpoints = {
  loadUser: 'user',
  regionsByName: 'program-regions',
  applicationList: 'back-office/applications',
  constants: 'types',
  serviceGroups: 'program-service-groups',
  coverageMaps: 'coverage-maps',
  regionSlaTargets: 'region-sla-targets',
  userProfile: 'applications',
  getUserProfile: 'applications',
  notes: 'applications',
};

export const queryStringifyObject = (params) => {
  if (params && typeof params === 'object') {
    return `?${queryString.stringify(params)}`;
  }
  return '';
};

export const parseResposeErrorMessage = async response => response.json()
  .then(data => ((data && data.message) ? data.message : undefined));

const getRequest = async (serviceEndpoint, methodVerb) => { // eslint-disable-line
  return fetch(`${getApiUrl()}/${serviceEndpoint}`, {
    method: methodVerb || 'GET',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  })
    .then(async (response) => { // eslint-disable-line
      if (response.status === 200) {
        return response.json();
      }
      if (response.status === 401 && isBackOffice) {
        navtoLogin();
      } else {
        const err = await parseResposeErrorMessage(response);
        throw new Error(err);
      }
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};

const deleteRequest = async serviceEndpoint => getRequest(serviceEndpoint, 'DELETE');

const postRequest = async (serviceEndpoint, data, methodVerb) => {
  const method = methodVerb || 'POST';
  return fetch(`${getApiUrl()}/${serviceEndpoint}`, {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then(async (response) => { // eslint-disable-line
      if (response.status === 200) {
        return response.json();
      }

      if (response.status === 401 && isBackOffice) {
        navtoLogin();
      } else {
        const err = await parseResposeErrorMessage(response);
        throw new Error(err);
      }
    })
    .catch((error) => {
      throw new Error(error.message);
    });
};


const patchRequest = async (serviceEndpoint, data) => postRequest(serviceEndpoint, data, 'PATCH');

export default {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
};
